
interface PageLinkType {
  name: string;
  routeName: string;
}
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PageTabs extends Vue {
  @Prop() readonly pageLinks!: PageLinkType[];
  @Prop() readonly sectionName!: string;
}
